// extracted by mini-css-extract-plugin
export var sliderRange = "_cl-2";
export var sliderRoot = "_cl-0";
export var sliderThumb = "_cl-3";
export var sliderTrack = "_cl-1";